import { newNotification } from 'actions/ui';
import {
  RESET_VALIDATION_ERRORS,
  SET_VALIDATION_ERRORS,
  UPDATE_READ_ONLY_FIELDS,
} from 'constants/index';
import type { RootState } from 'reducers/types';
import type { Dispatch } from 'redux';
import { getCurrentLocale } from 'selectors';
import { supportUrl } from 'utils/flysiteUrls/flysiteUrls';
import { getI18nInstance } from 'utils/translations';

type ValidationErrors = Record<string, string[]>;
type DispatchAction = Dispatch<{ type: string; payload?: unknown }>;

export const setValidationErrors =
  (
    errors: ValidationErrors,
    excludeUpdateReadOnlyFields?: string[],
    displayValidationErrors = true,
  ) =>
  (dispatch: DispatchAction) => {
    const updateReadOnlyPayload: Record<string, string[]> = {};

    for (const [key, value] of Object.entries(errors)) {
      if (!excludeUpdateReadOnlyFields?.includes(key)) {
        updateReadOnlyPayload[key] = value;
      }
    }

    if (displayValidationErrors) {
      dispatch({
        type: UPDATE_READ_ONLY_FIELDS,
        payload: updateReadOnlyPayload,
      });

      return dispatch({
        type: SET_VALIDATION_ERRORS,
        payload: errors,
      });
    }

    return { type: 'VALIDATION_ERRORS_TRACKED' };
  };

export const setTermsErrors = () => {
  const error = { are_terms_accepted: ['not accepted'] };
  return setValidationErrors(error);
};

export const resetValidationErrors = () => ({
  type: RESET_VALIDATION_ERRORS,
});

export const taxErrorNotification =
  () => (dispatch: DispatchAction, getState: () => RootState) => {
    const state = getState();
    const locale = getCurrentLocale(state);
    const i18n = getI18nInstance(locale);

    dispatch(
      newNotification({
        message: i18n.t('taxError.message', {
          contactUrl: supportUrl(locale),
        }),
        type: 'error',
      }),
    );
  };
